import { Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from '../../text'
import { IconContext, InfoIcon, WarningIcon } from '@phosphor-icons/react'

type InfoTextProps = {
    variant: 'information' | 'error'
    size: 'small' | 'medium'
    text: string
}

export function InfoText({ variant, size = 'small', text }: InfoTextProps) {
    return (
        <Stack direction="row" gap={tokens.SizingSpacing100} alignItems="center" role={variant === 'error' ? 'alert' : undefined}>
            <IconContext.Provider
                value={{
                    size: size === 'small' ? tokens.SizingIconS : tokens.SizingIconM,
                    weight: size === 'small' ? 'bold' : undefined,
                }}
            >
                {variant === 'error' ? (
                    <WarningIcon color={tokens.ColorIconDanger} style={{ flexShrink: 0 }} />
                ) : (
                    <InfoIcon color={tokens.ColorIconInformative} style={{ flexShrink: 0 }} />
                )}
            </IconContext.Provider>

            <Typography
                variant={size === 'small' ? 'textXS' : 'textS'}
                color={variant === 'error' ? tokens.ColorTextDangerSubtle : tokens.ColorTextInformativeSubtle}
            >
                {text}
            </Typography>
        </Stack>
    )
}
